<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">
      {{modalTitle}}
    </h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>
  
  <!-- Modal Body -->
  <div class="modal-body" id="mainTable" [hidden]="minimise">
    <br>
    <br>
    <div>
      <table class="table table-bordered text custom-table">
        <thead>
          <tr>
            <th>LEID</th>
            <th>Tax Year</th>
            <th>Currency</th>
            <th>Exchange Rate to USD</th>
            <th>(a) Actual RAF Amount</th>
            <th>(b) Actual Tax Return Amount or Additional Adjustment</th>
            <th>(b)-(a) True-Up Amount FC</th>
            <th>True-Up Amount USD</th>
            <th>Comments</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (obj of objects; track $index) {
<tr>
            <td>
              <div class="form-group">
                <div class="col-md-12">
                  <div class="input-group autocomplete-wrapper">
                    <input 
                      required 
                      type="text" 
                      class="input-sm form-control" 
                      name="account"
                      placeholder="begin typing to Search for an entity by GOLD ID, Mars/CDR or name"
                      [(ngModel)]="obj.selectedEntityDisplay"
                      (ngModelChange)="onEntitySearch($event, obj)"
                      (blur)="closeEntityDropdown(obj)"
                      [disabled]="editExistingEntity === false">
                    <span class="input-group-addon">
                      @if (obj.loadingEntities) {
<span>
                        <i class="fa fa-spinner fa-pulse"></i>
                      </span>
}
                      @if (!obj.loadingEntities) {
<span>
                        <i class="fa fa-search"></i>
                      </span>
}
                    </span>
                    
                    <!-- Autocomplete Dropdown -->
                    @if (obj.showEntityDropdown && obj.entitySearchResults && obj.entitySearchResults.length > 0) {
<div class="autocomplete-dropdown" 
                        >
                      @for (entity of obj.entitySearchResults; track $index) {
<div class="autocomplete-item" 
                          
                           (mousedown)="onSelectEntity(entity, obj)">
                        {{ entity.DISPLAY_VALUE }}
                      </div>
}
                    </div>
}
                    
                    <!-- No Results Message -->
                    @if (obj.showEntityDropdown && obj.entitySearchResults && obj.entitySearchResults.length === 0 && !obj.loadingEntities) {
<div class="autocomplete-dropdown no-results" 
                        >
                      <div class="autocomplete-item">No results found</div>
                    </div>
}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="col-md-2">{{obj.year}}</div>
            </td>
            <td width="10%">
              <div class="col-md-100">
                <select 
                  class="form-control selectpicker"
                  [(ngModel)]="obj.currency">
                  <option value="">Select Functional Currency</option>
                  @for (currency of obj.currencies; track $index) {
<option [ngValue]="currency">
                    {{currency.CURR_CODE}} - {{currency.CURR_DESC}}
                  </option>
}
                </select>
              </div>
            </td>
            <td width="10%">
              <input 
                type="text" 
                id="PrincipalCCYRate" 
                name="PrincipalCCYRate" 
                [(ngModel)]="obj.principalCCYRate" 
                (blur)="calcTaxAmount(obj)" 
                pattern="^(0100{1,1}\.?((?<=\.)0)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$" 
                maxlength="11"
                class="form-control input-sm">
            </td>
            <td width="10%">
              <input 
                type="text" 
                id="TaxesAmount" 
                name="TaxesAmount" 
                [(ngModel)]="obj.taxesAmount" 
                (blur)="calcTaxAmount(obj)" 
                onlyDigitsDecimal
                class="text-right form-control input-sm numText">
            </td>
            <td width="10%">
              <input 
                type="text" 
                id="TLCAmount" 
                name="TLCAmount" 
                [(ngModel)]="obj.TLCAmount" 
                (blur)="calcTaxAmount(obj)" 
                onlyDigitsDecimal
                class="text-right form-control input-sm numText">
            </td>
            <td>
              <div class="col-md-2">{{obj.adjInFC}}</div>
            </td>
            <td>
              <div class="col-md-2" maxlength="11">{{obj.adjInUSD}}</div>
            </td>
            <td>
              <textarea 
                cols="10" 
                maxlength="4000" 
                wrap="hard" 
                name="usrcomments" 
                class="form-control" 
                [(ngModel)]="obj.usrcomments"></textarea>
            </td>
            <td class="action-cell">
              <button 
                class="btn btn-info btn-sm" 
                type="button" 
                (click)="singleRowSave(obj, false)"
                [disabled]="obj.savingRow || obj.deletingRow">
                @if (obj.savingRow) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
                Save
              </button>
              @if (obj.isEdit) {
<button 
                
                class="btn btn-info btn-sm" 
                type="button" 
                (click)="singleRowSave(obj, true)"
                [disabled]="obj.savingRow || obj.deletingRow">
                @if (obj.deletingRow) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
                Delete
              </button>
}
            </td>
          </tr>
}
        </tbody>
      </table>
    </div>
    
    @if (editExistingEntity) {
<div class="modal-footer">
      <button 
        class="btn btn-info btn-sm" 
        type="button"
        (click)="addNew({})">
        Add New
      </button>
    </div>
}
  </div>
</div>

